import { mapGetters } from "vuex"
import { isAccessible } from "@/utils/navigationUtils"

// Helper pour les barres de navigations des formulaires.
// expose isAccessible()
export default {
  computed: {
    ...mapGetters({
      autorisations: "AutorisationDePratique/GET_AUTORISATIONSDEPRATIQUE",
    }),
  },
  methods: {
    isAccessible (tab) {
      return isAccessible(tab, this.autorisations)
    },
  },
}